<template>
  <div :class="$style.h5sdk" :style="{ backgroundImage: `url('${background}')` }">
    <!-- 手机注册 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.cellRegisterVisible">
      <cell-register @back="redirectLogin" @register="handleCellRegister" @redirectArgument="redirectArgument"></cell-register>
    </div>
    <!-- 快速注册 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.quickRegisterVisible">
      <quick-register
        @redirectLogin="redirectLogin"
        @redirectPhoneRegister="redirectPhoneRegister"
        @register="handleQuickRegister"
        @redirectArgument="redirectArgument"
      ></quick-register>
    </div>
    <!-- 登录 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.loginVisible">
      <Login @login="handleLogin" @redirectRegist="redirectRegist" @redirectForget="redirectForget"  @redirectArgument="redirectArgument"></Login>
    </div>
    <!-- 忘记密码 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.resetVisible">
      <Reset @back="redirectLogin"></Reset>
    </div>
    <!-- 悬浮球 -->
    <Suspend v-if="userState.suspendVisible"></Suspend>
    <!-- 悬浮窗 -->

    <!-- 公告 -->
    <Affiche v-if="userState.afficheShow" @close="closeAffiche"></Affiche>
    <!-- 强更新活动 -->
    <ForceUpdate v-if="userState.forceUpdateVisible"></ForceUpdate>
    <!-- 防沉迷 -->
    <AntiIndulged v-if="userState.antiIndulgedVisible" @notifyLogin="enterGame"></AntiIndulged>
    <!-- 支付 -->
    <Charge v-if="userState.chargeVisible" @close="closeChargeWindow"></Charge>
    <!-- 滑块验证 -->
    <Captcha :class="$style.captcha" v-show="userState.captchaVisible" @captchaInit="captchaInit"></Captcha>
    <!-- vip客服 -->
    <VipCustomer v-if="userState.vipVisible"></VipCustomer>
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.argumentVisible">
      <Argument @redirectRegist="argumentReturn"></Argument>
    </div>
    <FloatWindow v-if="userState.floatWindowVisible"></FloatWindow>
    <!-- 强制绑定手机 -->
    <ForceBindPhone v-if="userState.forceBindVisible" @close="closeForceBind"></ForceBindPhone>
    <!-- 应用宝登录框 -->
    <!-- <YybLogin v-if="userState.yybLoginVisible"></YybLogin> -->
    <!-- 游戏frame -->
    <iframe
      :class="$style.gameFrame"
      name="gameFrame"
      :src="userState.game_url"
      v-if="userState.gameVisible"
    ></iframe>
    <!-- 活动页 -->
    <ActivityPage v-if="activityShowInfo.visible"></ActivityPage>
    <!-- 冻结账号强制下线弹窗 -->
    <ForceOffline v-if="userState.forceOfflineVisible"></ForceOffline>
    <!-- 收到优惠券提示 -->
    <!-- <VoucherHint v-if="voucherState.voucherHintVisible"></VoucherHint> -->
    <!-- 强更转移礼包 -->
    <UpdateGift v-if="userState.updateGiftVisible" @close="closeUpdateGift"></UpdateGift>
  </div>
</template>
<script>
import QuickRegister from '@/components/login/Register.vue';
import CellRegister from '@/components/login/CellRegister.vue';
import Login from '@/components/login/Login.vue';
import Suspend from './suspend.vue';
import Reset from '@/components/login/Forgetpswds/common.vue';
import Affiche from '@/components/login/Affiche/common.vue';
import ForceUpdate from '@/components/update/Activity.vue';
import AntiIndulged from './antiIndulged.vue';
import Charge from '@/components/charge/Charge/common.vue'
import Captcha from '@/components/login/Captcha/common.vue'
import VipCustomer from './vipCustomer.vue'
import Argument from '@/components/login/Argument/common.vue'
import FloatWindow from './floatWindow.vue'
import ForceBindPhone from '@/components/login/ForceBindPhone/common.vue'
// import YybLogin from './yybLogin'
import ActivityPage from './activityPage.vue'
import ForceOffline from './forceOffline.vue'
import UpdateGift from '@/components/update/Gift.vue'
// import VoucherHint from './voucher/hint'

import { mapState } from 'vuex';
import { isAndroid } from '@/libs/utils.js';
import {
  thirdPartyLogins,
  registJSInitial,
  innerPurchaseFunctionSuc,
  closeOrderFrame,
  checkOrderState,
  deviceFlip2H5,
  onBackPressed2H5,
  didReceiveMemoryWarning
} from '@/bridge/AppJsBridge';
import { setStorage } from '@/libs/utils';
import { CaptchaInit, CaptchaReset } from "@/libs/captcha";
import { cpsRoute, insertLink, cpsCdnLink, cpsLogin } from '@/libs/business/cpsReport'

export default {
  data() {
    return {
      registerCallback: '', // 暂存滑块验证成功后需要调用的回调方法名
      cellForm: {}, // 手机滑块注册时暂存表单信息
      source: 0,
      cpsChannel: ''
    }
  },
  created() {
    if (!isAndroid()) this._iosInit();
    this.handleCpsReport()
    this.$store.commit('global/handleLinkParams', this.$route.query);
  },
  mounted() {
    this.$store.dispatch('user/getCacheState');
    this._bridgeInit();
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      voucherState: state => state.voucher,
      loginStatus: state => state.user.login_status,
      gameSrc: state => state.user.game_url,
      policyVisible: state => state.global.policyVisible,
      captchaStatus: state => state.user.captcha_status,
      activityShowInfo: state => state.activity.activity_show_info || {},
      background: state => state.user.background,
    })
  },
  watch: {
    // 初始化后监听captcha_status判断当前包是否开启滑块验证
    // captchaStatus(val) {
    //   if (val == '1') {
    //     this._captchaInit();
    //   }
    // }
  },
  components: {
    QuickRegister,
    CellRegister,
    Login,
    Suspend,
    Reset,
    Affiche,
    AntiIndulged,
    Charge,
    Captcha,
    VipCustomer,
    Argument,
    FloatWindow,
    ForceBindPhone,
    ActivityPage,
    ForceOffline,
    UpdateGift,
    ForceUpdate
  },
  methods: {
    _bridgeInit() {
      // 初始化客户端传过来的信息
      registJSInitial(async (e, cb) => {
        console.log('--- registJSInitial start ---')
        // ios h5通过链接获取设备参数，不会进这里
        let data = JSON.parse(e);
        const { user_info, jsDataStorage, third_sdk_status } = data;

        // 壳子缓存的用户列表不为空，则拿到用户列表
        if (user_info && user_info.length) {
          this.$store.commit('user/CHANGE_STATE', {
            userList: user_info,
            username: user_info[0].username,
            password: user_info[0].password
          });
        }
        // 存储传过来的信息
        this.$store.commit('user/CHANGE_STATE', {
          sdk_version: data.sdk_version,
          device_info: data.attributeReportParams,
          appkey: data.jh_app_id,
          channel: data.jh_channel,
          extra_data: JSON.stringify(data.extra_data),
          game_version: data.game_version,
          login_status: jsDataStorage || '',
          third_sdk_status: third_sdk_status || '',
          isEmulator: data.isEmulator,
          isInstallWeChat: data.isInstallWeChat,
          isInstallAlipay: data.isInstallAlipay,
        });

        // 强制正常登录
        if (third_sdk_status == 'false') {
          this.$store.commit('user/CHANGE_STATE', { login_status: 2 });
        }
        // 缓存信息
        const cacheList = [
          'login_status',
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status',
          'isEmulator',
          'isInstallWeChat',
          'isInstallAlipay'
        ];
        this.$store.dispatch('user/cacheState', cacheList);

        // 应用宝强制正常登录
        if (data.third_sdk_status === false) {
          setStorage('force_normal_login', 2);
        }

        this.$store.dispatch('user/getYsdkStatus', 1);
        this.$store.dispatch('user/affiche');
      });
      thirdPartyLogins((e, cb) => {
        console.log('--- third login start ---')
        let data = JSON.parse(e);
        if (data.isHuaWei) {
          // 针对华为审核不能存在第三方账号体系做处理
          this.$store.dispatch('user/huaweiThirdLogin');
        } else {
          this.$store.commit('user/CHANGE_STATE', { username: data.user_name, password: data.origncv });
          this.userState.loginStatus != 2 && this.$store.dispatch('user/login', true);
        }
      });
      // 应用宝内购
      innerPurchaseFunctionSuc(async (e, cb) => {
        console.log('--- 应用宝内购 ---')
        this.$store.commit('pay/CHANGE_STATE', { yyb_info: JSON.parse(e) });
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      });
      // 关闭订单窗口
      closeOrderFrame((e, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          orderIframeLink: '',
          orderShow: false,
          chargeOrNot: false
        });
        // 重复点击处理
        this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
      });
      // 查询订单结果
      checkOrderState((e, cb) => {
        this.$store.dispatch('pay/queryOrderResult');
      });
      // 手机翻转
      deviceFlip2H5((e, cb) => {
        this.$store.commit('user/CHANGE_STATE', { suspendVisible: !this.$store.state.user.suspendVisible });
      })
      onBackPressed2H5((e, cb) => {
        if (this.userState.game_url) {
          this.$store.commit('user/CHANGE_STATE', {
            cellRegisterVisible: false,
            quickRegisterVisible: false,
            loginVisible: false,
            resetVisible: false
          });
        }
        cb('onBackPressed2H5 success')
      })

      didReceiveMemoryWarning((e, cb) => {
        const memoryCallback = this.$store.state.message.memoryCallback;
        if (memoryCallback) {
          window.frames['gameFrame'].postMessage({ action: memoryCallback, params: e }, '*'); 
        }
      })

    },
    _iosInit() {
      const { initial, iosThirdPacket } = this.$route.query;
      if (iosThirdPacket) {
        // ios三方买包
        this.$store.dispatch('user/initIosThirdDeviceData', this.$route.query);
      } else if (initial) {
        // ios 非jsbridge形式传递设备信息处理
        this.$store.dispatch('user/initDeviceData', this.$route.query);
      }
    },
    captchaInit() {
      CaptchaInit(
        "captcha",
        (data) => {
          this.$store.commit("user/CHANGE_STATE", { captchaVisible: false });
          CaptchaReset()
          this.registerCallback && this[this.registerCallback](data);
        },
        (err) => {
          CaptchaReset()
          console.log(err);
        }
      );
    },
    handleCpsReport() {
      const { name } = this.$route;
      if (cpsRoute.includes(name)) {
        const cpsChannel = name.split('.')[0]
        // 标识是cps外放渠道
        this.cpsChannel = cpsChannel;
        localStorage.setItem('cpsChannel', cpsChannel);
        insertLink(cpsCdnLink[cpsChannel])
      }
    },
    // 滑块设置回调
    setRegisterCallback(cb, form) {
      this.registerCallback = cb;
      if (form) this.cellForm = form
    },
    async toLogin() {
      const r = await this.$store.dispatch('user/login');
      // 特殊情况
      if (r.content.login_status) {
        this.$store.commit('global/clearLoading')
        return;
      }

      // 登录后强制绑定手机判断
      const { force_bind_tel } = r.content;
      if ([1, 2, 3].includes(force_bind_tel)) {
        // force_bind_tel为2时提示用户绑定手机，但可正常进入游戏
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: true });
        this.$store.commit('global/clearLoading')
        return;
      }
      // 继续处理vip和防沉迷
      this.handleLoginInfo()
      if (this.cpsChannel) {
        cpsLogin[this.cpsChannel] && cpsLogin[this.cpsChannel](r.content.user_id);
      }
    },
    handleLoginInfo() {
      // vip判断
      this.$store.dispatch('user/checkVip');

      // 防沉迷判断
      this.$store.dispatch('user/checkAntiIndulged').then(() => {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: true });
        this.$store.commit('global/clearLoading')
      }).catch(() => this.enterGame());
    },
    closeForceBind(type) {
      const { force_bind_tel } = this.userState
      if (!type && force_bind_tel == 1) {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
      } else {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
        this.$store.commit('global/showLoading')
        this.handleLoginInfo()
      }
    },
    enterGame() {
      // 如果进了防沉迷流程，关闭防沉迷窗口使用
      if (this.userState.antiIndulgedVisible) {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: false });
        this.$store.commit('global/showLoading')
      }
      if (this.userState.h5Preload) {
        // 如果开启了h5预加载，登录成功后再调用研发回调
        this.$store.dispatch('message/notifyLogin');
      } else {
        this.$store.dispatch('message/monitorInit')
        this.$store.commit('user/CHANGE_STATE', { gameVisible: true });
      }
    },
    handleLogin(form) {
      this.$store.commit('user/CHANGE_STATE', form);
      this.toLogin();
    },
    redirectRegist() {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
        loginVisible: false,
        quickRegisterVisible: true
      });
    },
    argumentReturn() {
      switch (this.source) {
        case 0:
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: true,
            quickRegisterVisible: false,
            argumentVisible: false,
            cellRegisterVisible: false
          });
          break;
        case 1:
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: false,
            quickRegisterVisible: true,
            argumentVisible: false,
            cellRegisterVisible: false
          });
          break;
        case 2:
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: false,
            quickRegisterVisible: false,
            argumentVisible: false,
            cellRegisterVisible: true
          });
          break;
        default: 
          this.$store.commit("user/CHANGE_STATE", {
            loginVisible: false,
            quickRegisterVisible: true,
            argumentVisible: false,
            cellRegisterVisible: false
          });
          break;
      }
    },
    redirectForget() {
      this.$store.commit('user/CHANGE_STATE', {
        loginVisible: false,
        resetVisible: true
      });
    },
    redirectLogin() {
      this.$store.commit('user/CHANGE_STATE', {
        cellRegisterVisible: false,
        quickRegisterVisible: false,
        resetVisible: false,
        loginVisible: true
      });
    },
    redirectPhoneRegister() {
      this.$store.commit('user/CHANGE_STATE', {
        quickRegisterVisible: false,
        cellRegisterVisible: true
      });
    },
    async handleQuickRegister() {
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit('user/CHANGE_STATE', {
          captchaVisible: true
        });
        this.setRegisterCallback('captchaQuickRegister');
        return;
      }
      await this.$store.dispatch('user/quickRegister');
      this.toLogin();
    },
    async handleCellRegister(form) {
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit('user/CHANGE_STATE', {
          captchaVisible: true
        });
        this.setRegisterCallback('captchaCellRegister', form);
        return;
      }
      await this.$store.dispatch('user/cellRegister', form);
      this.toLogin();
    },
    closeAffiche() {
      this.$store.commit('user/CHANGE_STATE', { afficheShow: false });
    },
    closeChargeWindow() {
      if (window.queryInterval) clearInterval(window.queryInterval);
      this.$store.commit('user/CHANGE_STATE', { chargeVisible: false });
    },
    closeUpdateGift() {
      this.$store.commit('user/CHANGE_STATE', { updateGiftVisible: false });
    },
    redirectArgument(type, source) {
      this.source = source;
      this.$store.commit('user/CHANGE_STATE', {
        quickRegisterVisible: false,
        argumentVisible: true,
        argumentType: type,
      })
    },
    /**
    * 带滑块验证的快速注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaQuickRegister (validData) {
      await this.$store.dispatch('user/quickRegister', validData);
      await this.toLogin();
    },
    /**
    * 带滑块验证的手机注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaCellRegister (validData) {
      await this.$store.dispatch('user/cellRegister', { ...this.cellForm, validData });
      await this.toLogin();
    }
  }
}

</script>

<style lang="scss" module>
.h5sdk {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .gameFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    /* background: #000000; */
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }

  .mask {
    background: rgba(0, 0, 0, 0.6);
  }
  .outer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .captcha {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 350px;
    height: 270px;
  }
}
</style>